// apilinks.js
const ApiLinks = {
  login: "Auth/login",
  //
  ItemGroup: "itemgroup/GetAll",
  ItemGroup_Delete: "itemgroup/Delete",
  ItemGroup_GetById: "itemgroup/GetById",
  ItemGroup_Save: "itemgroup/Add",
  ItemGroup_Update: "itemgroup/Update",

  Unit: "unit/GetAll",
  Unit_Delete: "unit/Delete",
  Unit_GetById: "unit/GetById",
  Unit_Save: "unit/Add",
  Unit_Update: "unit/Update",

  Item: "itemMaster/GetAll",
  Item_Delete: "itemMaster/Delete",
  Item_GetById: "itemMaster/GetById",
  Item_Save: "itemMaster/Add",
  Item_Update: "itemMaster/Update",

  Party: "partyMaster/GetAll",
  Party_Delete: "partyMaster/Delete",
  Party_GetById: "partyMaster/GetById",
  Party_Save: "partyMaster/Add",
  Party_Update: "partyMaster/Update",

  Terms: "terms/GetAll",
  Terms_Delete: "terms/Delete",
  Terms_GetById: "terms/GetById",
  Terms_Save: "terms/Add",
  Terms_Update: "terms/Update",


  Quotation: "quotation/GetAll",
  Quotation_Delete: "quotation/Delete",
  Quotation_GetById: "quotation/GetById",
  Quotation_Save: "quotation/Add",
  Quotation_Update: "quotation/Update",
  Quotation_UpdateStatus: "quotation/UpdateStatus",
  Quotation_UpdateRejection: "quotation/UpdateRejection",
  Quotation_UpdateExecution: "quotation/UpdateExecution",
  Quotation_UpdateDispatch: "quotation/UpdateDispatch",



  PaymentReceived_Add: "PaymentReceived/Add",
  PaymentReceived_Delete: "PaymentReceived/Delete",
  PaymentReceived_GetAll: "PaymentReceived/GetAll",



  PFIissued_Add: "PFIissued/Add",
  PFIissued_GetAll: "PFIissued/GetAll",
  PFIissued_Delete: "PFIissued/Delete",

};

export default ApiLinks;
